import React, { useEffect } from 'react';
import Button from './Button';

const SuccessPage = ({ navigate }) => {
  // Clear any query parameters and properly update App routing state
  useEffect(() => {
    if (window.location.search.includes('success=true')) {
      // Use navigate to update currentPath state in App.js so it doesn't revert to home
      navigate('/success', {}, true);
    }
  }, [navigate]);

  return (
    <div className="py-32 max-w-[95vw] mx-auto px-4 md:px-8 min-h-[80vh] flex flex-col items-center justify-center bg-background">
      <div className="max-w-2xl mx-auto w-full text-center border-2 border-accent bg-accent/5 p-12 space-y-8 shadow-[12px_12px_0px_#0101ff]">
        <div className="w-24 h-24 bg-accent text-accent-foreground rounded-full flex items-center justify-center mx-auto mb-8 border-4 border-background">
          <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="square" strokeLinejoin="miter" strokeWidth="3" d="M5 13l4 4L19 7"></path>
          </svg>
        </div>
        
        <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter leading-none text-foreground" style={{ fontFamily: "'Poppins Black', sans-serif" }}>
          PAYMENT SUCCESSFUL
        </h1>
        
        <div className="w-16 h-1 bg-accent mx-auto"></div>
        
        <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
          Your project is officially in motion. We've just sent a confirmation email to the address you provided.
        </p>
        
        <div className="bg-background border-2 border-border p-6 mt-8">
          <h3 className="font-bold text-lg uppercase tracking-widest text-foreground mb-2">Next Step</h3>
          <p className="text-muted-foreground text-sm">
            Please check your inbox (and spam folder) for an email from WIND Marketing. It contains a link to book your onboarding kickoff call.
          </p>
        </div>
        
        <div className="pt-8 flex justify-center">
          <Button size="large" onClick={() => navigate('/')}>
            RETURN TO HOME
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
